const COOKIE_CHECK_INTERVAL = 200;
const COOKIE_CHECK_MAX_ATTEMPS = 50;

class Clarity {
  timeout: number | null;

  cookieName: string;

  cookieValue: string | null;

  clarityId: string | null;

  constructor() {
    this.timeout = null;
    this.cookieName = '_clck';
    this.cookieValue = null;
    this.clarityId = null;
  }

  getClarityId() {
    if (this.clarityId) {
      return Promise.resolve(this.clarityId);
    }
    const promise = new Promise((resolve, reject) => {
      this.lookForClarityId(0, (clarityId) => {
        this.clarityId = clarityId;
        resolve(clarityId);
      }, reject);
    });
    return promise;
  }

  private lookForClarityId(
    attempCount: number,
    onSuccess: (clarityID: string) => void,
    onFailure: (reason: string) => void,
  ) {
    this.timeout = window.setTimeout(() => {
      const clarityCookie = document.cookie.split(';')
        .find((cookie) => cookie.trim().startsWith(this.cookieName));
      if (clarityCookie) {
        this.cookieValue = clarityCookie.trim().slice(this.cookieName.length + 1);
        const [clarityID] = this.cookieValue.split('|');
        onSuccess(clarityID);
      } else if (attempCount < COOKIE_CHECK_MAX_ATTEMPS) {
        this.lookForClarityId(attempCount + 1, onSuccess, onFailure);
      } else {
        onFailure('Clarity ID not found');
      }
    }, COOKIE_CHECK_INTERVAL);
  }
}

export default Clarity;
